// activeDel/submits/slice.js

import { activeDelSubmitsInitialState } from "./activeDelsSubmitsState";
import { makeActiveDelSubmitsActions } from "./activeDelsSubmitsActions";

export const createActiveDelSubmitsSlice = (set, get) => ({
  activeDelSubmits: activeDelSubmitsInitialState,
  activeDelSubmitsActions: Object.freeze(makeActiveDelSubmitsActions(set, get)),
});
